import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import imagesLoaded from 'imagesloaded';
import SplitText from '../gsap-bonus/SplitText';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('lazyloaded', () => {
    ScrollTrigger.refresh();
});

export function initReveal() {
    const item = [...document.querySelectorAll('[data-reveal]')];

    item.forEach((item, index) => {
        imagesLoaded('#app', () => {
            const { revealDelay, revealManually, revealPosition } =
                item.dataset;
            if (revealManually === '') {
                return;
            }

            if (revealPosition) {
                console.log(revealPosition);
            }

            const startPercentage = revealPosition || '80%';

            gsap.timeline({
                scrollTrigger: {
                    markers: false,
                    trigger: item,
                    start: `top ${startPercentage}`,
                    onEnter: () => {
                        if (!revealDelay) {
                            item.classList.add('--revealed');
                            return;
                        }

                        gsap.delayedCall(revealDelay, () => {
                            item.classList.add('--revealed');
                        });
                    },
                },
            });
        });
    });
}

export function initImageReveal() {
    const item = [...document.querySelectorAll('[data-image-reveal]')];

    item.forEach((item, index) => {
        imagesLoaded('#app', () => {
            const {
                revealDelay,
                revealManually,
                revealPosition,
                revealSliderEmit,
            } = item.dataset;
            if (revealManually === '') {
                return;
            }

            if (revealPosition) {
                console.log(revealPosition);
            }

            const startPercentage = revealPosition || '70%';

            gsap.timeline({
                scrollTrigger: {
                    markers: false,
                    trigger: item,
                    start: `top ${startPercentage}`,
                    onEnter: () => {
                        if (!revealDelay) {
                            item.classList.add('--revealed');
                            item.querySelector('.image-shadow').classList.add(
                                'image-shadow--visible'
                            );

                            if (revealSliderEmit === '') {
                                gsap.delayedCall(1, () => {
                                    EventBus.$emit('slider-reveal');
                                });
                            }

                            return;
                        }

                        gsap.delayedCall(revealDelay, () => {
                            item.classList.add('--revealed');
                            item.querySelector('.image-shadow').classList.add(
                                'image-shadow--visible'
                            );

                            if (revealSliderEmit === '') {
                                gsap.delayedCall(1, () => {
                                    EventBus.$emit('slider-reveal');
                                });
                            }
                        });
                    },
                },
            });
        });
    });
}

export function initSplitlinesReveal() {
    const selector = document.querySelectorAll('.split-lines-reveal');

    for (let index = 0; index < selector.length; index++) {
        const item = selector[index];

        // Continue with default splittext reveal logic
        gsap.set(item, { opacity: 1 });

        const split = new SplitText(item, {
            type: 'lines',
            linesClass: 'split-lines-reveal__line',
        });

        for (let index = 0; index < split.lines.length; index++) {
            const line = split.lines[index];
            let inner = line.innerHTML;
            inner = `<div class="split-lines-reveal__line-inner">${inner}</div>`;
            line.innerHTML = inner;
            line.style.overflow = 'hidden';
        }
        gsap.set('.split-lines-reveal__line-inner', {
            translateY: '100%',
            opacity: 0,
        });

        const startPercentage = '80%';

        imagesLoaded('#app', () => {
            selector.forEach((element) => {
                ScrollTrigger.create({
                    markers: false,
                    trigger: element,
                    start: `top ${startPercentage}`,
                    onToggle: () => {
                        gsap.to(
                            element.querySelectorAll(
                                '.split-lines-reveal__line-inner'
                            ),
                            {
                                translateY: '0%',
                                opacity: 1,
                                duration: 1,
                                stagger: 0.1,
                                ease: 'power4.out',
                            }
                        );
                    },
                });
            });
        });
    }
}
